import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=6ee6461a&scoped=true&"
import script from "./secondStep.vue?vue&type=script&lang=js&"
export * from "./secondStep.vue?vue&type=script&lang=js&"
import style0 from "./secondStep.vue?vue&type=style&index=0&id=6ee6461a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee6461a",
  null
  
)

export default component.exports